"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TargetFactory", {
    enumerable: true,
    get: function() {
        return TargetFactory;
    }
});
const _targetId = require("./targetId.js");
const _getWeight = require("./getWeight.js");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class TargetFactory {
    getTargetType(task, config) {
        if (!config.type) {
            if (this.packageScripts.has(task)) {
                return "npmScript";
            } else {
                return "noop";
            }
        }
        return config.type;
    }
    /**
   * Creates a package task `Target`
   * @param packageName
   * @param task
   * @param config
   * @returns a package task `Target`
   */ createPackageTarget(packageName, task, config) {
        const { resolve } = this.options;
        const { options, deps, dependsOn, cache, inputs, priority, maxWorkers, environmentGlob, weight } = config;
        const cwd = resolve(packageName);
        const targetType = this.getTargetType(task, config);
        const target = {
            id: (0, _targetId.getTargetId)(packageName, task),
            label: `${packageName} - ${task}`,
            type: targetType,
            packageName,
            task,
            cache: cache !== false,
            cwd,
            depSpecs: dependsOn ?? deps ?? [],
            dependencies: [],
            dependents: [],
            inputs,
            outputs: targetType === "noop" ? [] : config.outputs,
            priority,
            maxWorkers,
            environmentGlob,
            weight: 1,
            options,
            shouldRun: true
        };
        target.weight = (0, _getWeight.getWeight)(target, weight, maxWorkers);
        return target;
    }
    createGlobalTarget(id, config) {
        const { root } = this.options;
        const { options, deps, dependsOn, cache, inputs, outputs, priority, maxWorkers, environmentGlob, weight } = config;
        const { task } = (0, _targetId.getPackageAndTask)(id);
        const target = {
            id,
            label: id,
            type: this.getTargetType(task, config),
            task,
            cache: cache !== false,
            cwd: root,
            depSpecs: dependsOn ?? deps ?? [],
            dependencies: [],
            dependents: [],
            inputs,
            outputs,
            priority,
            maxWorkers,
            environmentGlob,
            weight: 1,
            options,
            shouldRun: true
        };
        target.weight = (0, _getWeight.getWeight)(target, weight, maxWorkers);
        return target;
    }
    /**
   * Creates a target that operates on files that are "staged" (git index)
   */ createStagedTarget(task, config, changedFiles) {
        const { root } = this.options;
        const { dependsOn, priority } = config;
        // Clone & modify the options to include the changed files as taskArgs
        const options = {
            ...config.options
        };
        switch(config.type){
            case "noop":
                break;
            default:
                options.taskArgs = options.taskArgs ?? [];
                options.taskArgs.push(...changedFiles);
                break;
        }
        const id = (0, _targetId.getStagedTargetId)(task);
        const target = {
            id,
            label: id,
            type: config.type,
            task,
            cache: false,
            cwd: root,
            depSpecs: dependsOn ?? [],
            dependencies: [],
            dependents: [],
            inputs: [],
            outputs: [],
            priority,
            maxWorkers: 1,
            environmentGlob: [],
            weight: 1,
            options,
            shouldRun: true
        };
        return target;
    }
    constructor(options){
        _define_property(this, "options", void 0);
        _define_property(this, "packageScripts", void 0);
        this.options = options;
        this.packageScripts = new Set();
        const { packageInfos } = options;
        for (const info of Object.values(packageInfos)){
            for (const scriptName of Object.keys(info.scripts ?? {})){
                this.packageScripts.add(scriptName);
            }
        }
    }
}
